<template>
    <div class="bg-white py-3 px-5 my-3 final-evaluation">
        <div class="d-flex align-items-end">
            <h4 class="text-primary mb-0">
                {{ $t('surgery.finalEvaluation') }}
            </h4>
            <i
                class="fas fa-pen clickable ml-2 edit"
                style="font-size: 1.2rem; position: relative; bottom: 4px;"
                @click="$emit('edit')"
            />
        </div>

        <br>

        <div class="column-container">
            <display-field
                :field="finalEvaluationFields.total_novoeight"
                :value="surgery.final_evaluation.total_novoeight"
                :label="$t('surgery.totalNovoeight')"
                class="d-flex align-items-end"
            >
                <template v-slot:after-value>
                    <img src="@/assets/icons/novoeight_icon.svg" style="height: 1.8rem"/>
                </template>
            </display-field>
            <display-field :field="surgeryFields.hospitalization_date" >
                {{ surgery.hospitalization_date | datetime({showDay: false}) }}
            </display-field>
            <display-field :field="finalEvaluationFields.discharge_patient_date">
                {{ surgery.final_evaluation.discharge_patient_date | datetime({showDay: false}) | valueOrEmpty }}
            </display-field>
            <display-field
                :field="finalEvaluationFields.admission_days"
                :value="surgery.final_evaluation.admission_days"
            />
            <display-choice-field
                :field="finalEvaluationFields.inhibitors_3_months"
                :value="surgery.final_evaluation.inhibitors_3_months"
            />
        </div>

        <div class="column-container">
            <display-field :field="finalEvaluationFields.iron">
                {{ surgery.final_evaluation.iron | yesnonull | capitalize  }}
            </display-field>
            <display-field :field="finalEvaluationFields.has_allergic_reaction" >
                {{ surgery.final_evaluation.has_allergic_reaction | yesnonull | capitalize }}
            </display-field>
            <display-field :field="finalEvaluationFields.allergic_reaction_date" >
                {{ surgery.final_evaluation.allergic_reaction_date | date({showDay: false}) | valueOrEmpty }}
            </display-field>
            <display-choice-field
                :field="finalEvaluationFields.allergic_reaction_seriousness"
                :value="surgery.final_evaluation.allergic_reaction_seriousness"
            />
            <display-field
                :field="finalEvaluationFields.allergic_reaction_comments"
                :value="surgery.final_evaluation.allergic_reaction_comments"
            />
        </div>

        <div class="column-container">
            <display-field :field="finalEvaluationFields.has_thrombosis" >
                {{ surgery.final_evaluation.has_thrombosis | yesnonull | capitalize }}
            </display-field>
            <display-field :field="finalEvaluationFields.thrombosis_date" >
                {{ surgery.final_evaluation.thrombosis_date | date({showDay: false}) | valueOrEmpty }}
            </display-field>
            <display-field
                :field="finalEvaluationFields.thrombosis_type"
                :value="surgery.final_evaluation.thrombosis_type"
            />

            <display-field
                :field="finalEvaluationFields.adverse_reaction"
                :value="surgery.final_evaluation.adverse_reaction"
            />
            <display-field
                :field="finalEvaluationFields.hemorrhages"
                :value="surgery.final_evaluation.hemorrhages"
            />
            <display-field
                :field="finalEvaluationFields.treament_others"
                :value="surgery.final_evaluation.treament_others"
            />
        </div>

        <hr v-if="surgery.final_evaluation.complications" class="bg-primary">

        <display-field :field="finalEvaluationFields.complications" :value="surgery.final_evaluation.complications"/>

        <hr v-if="surgery.final_evaluation.outpatient_treatments.length > 0" class="bg-primary">

        <div
            v-for="(adjuvant, index) in surgery.final_evaluation.outpatient_treatments"
            :key="'adjuvant' + index"
            class="column-container"
        >
            <div class="treatment">
                <span class="text-primary">
                    {{ adjuvant.treatment_type | choice(finalEvaluationFields.outpatient_treatments.child.children.treatment_type) }}
                </span>
            </div>
            <display-field
                :field="finalEvaluationFields.outpatient_treatments.child.children.days"
                :value="adjuvant.days"
                class="treatment"
            />
            <display-field
                v-if="adjuvant.treatment_type === 'novoeight'"
                :field="finalEvaluationFields.outpatient_treatments.child.children.amount"
                :value="adjuvant.amount"
                class="treatment"
            />
        </div>

        <hr v-if="surgery.final_evaluation.readmissions.length > 0" class="bg-primary">

        <div
            v-for="(readmission, index) in surgery.final_evaluation.readmissions"
            :key="'readmission-' + index"
            class="d-inline-flex"
        >
            <div class="mr-2"><img src="@/assets/icons/readmission.svg"/></div>
            <div class="column-container align-items-start">
                <display-field :field=" finalEvaluationFields.readmissions.child.children.date" class="treatment">
                    {{ readmission.date | datetime({showDay: false}) | valueOrEmpty }}
                </display-field>
                <display-field
                    :field="finalEvaluationFields.readmissions.child.children.reason"
                    :value=" readmission.reason"
                    class="treatment"
                />
            </div>
        </div>

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import DisplayField from "@/components/DisplayField";
    import DisplayChoiceField from "@/components/DisplayChoiceField";

    export default {
        name: 'FinalEvaluationDisplay',
        components: {DisplayChoiceField, DisplayField},
        computed: {
            ...mapState([
                'surgery',
                'surgeryFields',
                'finalEvaluationFields',
            ]),
        },
    };
</script>

<style scoped lang="scss">
    @import "../../custom";

    .column-container {
        @extend .d-inline-flex;
        @extend .flex-column;
        @extend .mr-5;
        @extend .mb-3;

        label {
            @extend .form-label;
            @extend .mr-1;
        }

        .treatment {
            @extend .mr-5;
        }
    }

</style>
